import { Modal } from "antd";
import { Dispatch, SetStateAction } from "react";
import styles from "./DirectDebitStyles.module.scss";

interface ConfirmMandateProps {
    showConfirmMandateApprovalModal: boolean;
    setShowConfirmMandateApprovalModal: Dispatch<SetStateAction<boolean>>
    isLoadingApproval: boolean;
    onApproveMandate: () => Promise<void>;
    approveMandateErrorMsg: string;
    setApproveMandateErrorMsg: Dispatch<SetStateAction<string>>;
}

const ConfirmMandateApproval = ({
    showConfirmMandateApprovalModal,
    setShowConfirmMandateApprovalModal,
    isLoadingApproval,
    onApproveMandate,
    approveMandateErrorMsg,
    setApproveMandateErrorMsg
}: ConfirmMandateProps) => {
    return (
        <Modal
            title="Confirm Mandate Approval"
            open={showConfirmMandateApprovalModal}
            zIndex={9990}
            onCancel={() => {
                setShowConfirmMandateApprovalModal(false)
                setApproveMandateErrorMsg("")
            }}
            footer={[
                <button
                    key="submit"
                    className={`btn advancly-btn ${styles.reject_btn}`}
                    disabled={isLoadingApproval}
                    onClick={onApproveMandate}
                >
                    {isLoadingApproval ? "Loading..." : "Approve"}
                </button>,
            ]}
        >
            {approveMandateErrorMsg && (
                <p className="alert alert-danger py-2">
                    {approveMandateErrorMsg}
                </p>
            )}

            <p>Are you sure you want to approve this mandate?</p>
        </Modal>

    )
}

export default ConfirmMandateApproval